export const transitionPeriodForSpCertificate = 90;
export const transitionPeriodForIdpCertificate = 60;